import { useState } from 'react';

export function usePasswordToggle() {
  const [visible, setVisible] = useState(false);
  const toggle = () => setVisible(prev => !prev);
  const inputType = visible ? 'text' : 'password';
  const icon = visible ? 'visibility' : 'visibility_off';
  return { visible, toggle, inputType, icon };
}
